import React from "react";

import "./RadioButtonGroup.scss";

export type RadioButtonGroupItem = {
  id: string;
  value: string;
  label: string;
};

type Props = {
  name: string;
  items: ReadonlyArray<RadioButtonGroupItem>;
  innerRef: (r: Element | null) => void;
  initValue?: string;
  className?: string;
};

function RadioButtonGroup({ name, items, initValue, className, innerRef }: Props) {
  return (
    <div className={`radio-button-group ${className || ""}`}>
      {items.map((item) => (
        <React.Fragment key={item.id}>
          <input
            type="radio"
            name={name}
            id={item.id}
            value={item.value}
            ref={innerRef}
            defaultChecked={initValue === item.value}
          />
          <label htmlFor={item.id}>{item.label}</label>
        </React.Fragment>
      ))}
    </div>
  );
}

export default RadioButtonGroup;
